export default (string: string) => {
  if (!string) return '';
  const parser = new DOMParser();
  return parser.parseFromString(string, 'text/html').body.textContent || '';
};
